import Vue from 'vue'
import router from '../router'
import store from '../store/index'
import enquireJs from 'enquire.js'
import Cookies from 'js-cookie'


/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth(key: string) {
  return JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || false
}

/**
 * 清除登录信息
 */
export function clearLoginInfo() {
  Cookies.remove('token')
  store.commit('resetStore')
}

const enquireScreen = (call: any) => {
  const hanlder = {
    match() {
      call && call(true)
    },
    unmatch() {
      call && call(false)
    }
  }
  enquireJs.register('only screen and (max-width: 767.99px)', hanlder)
}

export default enquireScreen
